import 'jquery.cookie';

let getUrl = location.host;
/** スクロール一時禁止 **/
let fixdScrollpos;
export function scrollControlFunk(res) {
  //背景固定
  function controlStop() {
    fixdScrollpos = $(window).scrollTop();
    $('body').addClass('fixedBody').css({
      'top': -fixdScrollpos
    });
  }
  //背景固定解除
  function controlRelease() {
    $('body').removeClass('fixedBody').css({
      'top': 0
    });
    window.scrollTo(0, fixdScrollpos);
  }

  switch (res) {
    case 'stop':
      /*背景固定*/
      controlStop();
      break;
    case 'release':
      /*背景固定解除*/
      controlRelease(); 
      break;
  }
}

export function fadeInFunc() {
  const options = {
    root: null,
    threshold: 0
  };

  const callback = (function (changes) {
    for (let change of changes) {
      let target = change.target;
      if (change.isIntersecting) {
        target.classList.add('active');
      }
    }
  });

  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('.fadeIn')
  for (let target of targets) {
    observer.observe(target)
  }

  const images = document.querySelectorAll(".lazyload");
  new LazyLoad(images, {
    root: null,
    rootMargin: "0px",
    threshold: 0
  });
}

/** スクロール一時禁止 **/
let scroll_control = function (e) {
  e.preventDefault();
}
export function no_scroll() {
  document.addEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.addEventListener("touchmove", scroll_control, {
    passive: false
  });
}
export function return_scroll() {
  document.removeEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.removeEventListener('touchmove', scroll_control, {
    passive: false
  });
}

export function setCookie() {
var location = $.cookie('location');
  /*
  $.cookie('location', location, {
        path: '/',
        expires: 30,
        //testest
        domain:'.tenga.co'
      });  
  */
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    $.cookie('location', location, {
        path: '/',
        expires: 30,
        //testest
        domain:'.acceptee-tenga.com'
      }); 
  } else {
    $.cookie('location', location, {
        path: '/',
        expires: 30,
        //testest
        domain:'.tenga.co'
      }); 
  }
  
  //モーダル表示設定
$(".overlay").hide();
if ($.cookie('location') == undefined && $.cookie('enterKrFlag') == undefined) {
  no_scroll();
  $(".overlay").fadeIn();
} else if($.cookie('location') == 'kr' && $.cookie('enterKrFlag') == undefined) {
  no_scroll();
  $(".overlay").fadeIn();
  $(".areaSelectContainer").fadeOut();
  $(".eighteenMoreEnterContainer").fadeIn();
} else if ($.cookie('location') == 'kr' && $.cookie('enterKrFlag') == 'on') {
   $(".overlay").hide();
//cookieがus以外の場合は各言語版に遷移
} else if ($.cookie('location') == 'fr') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/fr/';
  } else {
    window.location.href = 'https://www.tenga.co/fr/';
  }
} else if ($.cookie('location') == 'uk') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/uk/';
  } else {
    window.location.href = 'https://www.tenga.co/uk/';
  }
} else if ($.cookie('location') == 'us') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/';
  } else {
    window.location.href = 'https://www.tenga.co/';
  }
} else if ($.cookie('location') == 'de') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/de/';
  } else {
    window.location.href = 'https://www.tenga.co/de/';
  }
} else if ($.cookie('location') == 'es') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/es/';
  } else {
    window.location.href = 'https://www.tenga.co/es/';
  }
} else if ($.cookie('location') == 'tw') {
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    window.location.href = 'http://global-tenga.acceptee-tenga.com/tw/';
  } else {
    window.location.href = 'https://www.tenga.co/tw/';
  }
}
  /*else if ($.cookie('location') == 'ja') {
  window.location.href = 'https://www.tenga.co.jp/';
} else if ($.cookie('location') == 'fr') {
window.location.href = 'https://www.tenga.co/fr/';
} else if ($.cookie('location') == 'de') {
  window.location.href = 'https://www.tenga.co/de/';
} else if ($.cookie('location') == 'es') {
  window.location.href = 'https://www.tenga.co/es/';
} else if ($.cookie('location') == 'ch') {
  window.location.href = 'http://www.tenga-cn.com/';
} else if ($.cookie('location') == 'tw') {
  window.location.href = 'https://www.tenga.co/tw/';
} else if ($.cookie('location') == 'kr') {
  window.location.href = 'https://www.tenga.co/kr/';
} else if ($.cookie('location') == 'tr') {
  window.location.href = 'http://www.tenga.com.tr/';
}*/
console.log($.cookie('location'));

//セレクトボックス表示設定（テキスト中央表示）
// selectと同じようにonchangeでラベルを変えたいときはJSを用いる
$('.locationSelect').on('change', function(){
  var $this = $(this);
  var $option = $this.find('option:selected');
  $('.label').text($option.text());
  // onchange後にフォーカスしてるのが嫌な場合
  $this.blur();
});
  
//モーダル内ロケーション選択設定
$(".btn_area button").click(function(){
  // セレクトボックスで選択したvalue値を変数に格納
  var location = $('#location').val();
  
  if ((location == 'us')||(location == 'fr')||(location == 'uk')||(location == 'de')||(location == 'es')||(location == 'kr')||(location == 'tw')) {
      if (getUrl == 'global-tenga.acceptee-tenga.com') {
        $.cookie('location', location, {
            path: '/',
            expires: 30,
            //testest
            domain:'.acceptee-tenga.com'
          });
      } else {
        $.cookie('location', location, {
            path: '/',
            expires: 30,
            //testest
            domain:'.tenga.co'
          });
      }
  }
  
  if (location == 'kr'){
    //$(".overlay").fadeOut();
    //return_scroll();
    $(".areaSelectContainer").fadeOut();
    $(".eighteenMoreEnterContainer").fadeIn();
    } else if (location == 'ja') {
    window.location.href = 'https://www.tenga.co.jp/';
  } else if (location == 'tr') {
    window.location.href = 'https://www.tenga.com.tr/';
  } else if (location == 'fr') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/fr/';
    } else {
      window.location.href = 'https://www.tenga.co/fr/';
    }
  } else if (location == 'uk') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/uk/';
    } else {
      window.location.href = 'https://www.tenga.co/uk/';
    }
  } else if (location == 'us') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/';
    } else {
      window.location.href = 'https://www.tenga.co/';
    }
  } else if (location == 'de') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/de/';
    } else {
      window.location.href = 'https://www.tenga.co/de/';
    }
  } else if (location == 'es') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/es/';
    } else {
      window.location.href = 'https://www.tenga.co/es/';
    }
  } else if (location == 'tw') {
    if (getUrl == 'global-tenga.acceptee-tenga.com') {
      window.location.href = 'http://global-tenga.acceptee-tenga.com/tw/';
    } else {
      window.location.href = 'https://www.tenga.co/tw/';
    }
  } else if (location == 'ch') {
    window.location.href = 'http://www.tenga-cn.com/';
  }

  console.log($.cookie('location'));
});

//18禁エンターボタンクリック時
$(".enter_btn_area button").click(function(){
  $(".overlay").fadeOut();
  return_scroll();
  if (getUrl == 'global-tenga.acceptee-tenga.com') {
    $.cookie('enterKrFlag', 'on', {
        path: '/',
        expires: 30,
        //testest
        domain:'.acceptee-tenga.com'
      });
  } else {
    $.cookie('enterKrFlag', 'on', {
        path: '/',
        expires: 30,
        //testest
        domain:'.tenga.co'
      });
  }
});
  
//フッター内ロケーション選択設定
var footerLocatinBtn = $('#jsLang ul li a');
$(footerLocatinBtn).click(function(){
  // セレクトボックスで選択したvalue値を変数に格納
  var location = $(this).attr('id');
  /*
    if(getUrl == 'global-tenga.acceptee-tenga.com'){
      $.cookie('location', location, { expires: 30, path: '/' });
    } else {
      $.cookie('location', location, { path: '/', expires: 30, secure:true});
    }
   
    if ((location == 'us')||(location == 'fr')) {
        $.cookie('location', location, {
          path: '/',
          expires: 30,
          //testest
          domain:'.tenga.co'
        });
    }
   */
  if ((location == 'us')||(location == 'fr')||(location == 'uk')||(location == 'de')||(location == 'es')||(location == 'kr')||(location == 'tw')) {
      if (getUrl == 'global-tenga.acceptee-tenga.com') {
        $.cookie('location', location, {
            path: '/',
            expires: 30,
            //testest
            domain:'.acceptee-tenga.com'
          }); 
      } else {
        $.cookie('location', location, {
            path: '/',
            expires: 30,
            //testest
            domain:'.tenga.co'
          }); 
      }
  }

  console.log($.cookie('location'));
});
};